import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type GetCustomerSidebarCountersQueryVariables = GraphQLTypes.Exact<{
  accountIds?: GraphQLTypes.InputMaybe<
    | Array<GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>>
    | GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>
  >;
  customerUuid?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  onlyManufacturerRequested?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Boolean']['input']>;
  onlyReadyForApproval?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Boolean']['input']>;
}>;

export type GetCustomerSidebarCountersQueryResult = { __typename?: 'Query' } & {
  bookingRequestsCount: { __typename?: 'BookingConnection' } & Pick<GraphQLTypes.BookingConnection, 'totalCount'>;
  quotesCount: { __typename?: 'BookingConnection' } & Pick<GraphQLTypes.BookingConnection, 'totalCount'>;
};

export const GetCustomerSidebarCountersDocument = gql`
  query getCustomerSidebarCounters(
    $accountIds: [String]
    $customerUuid: String
    $onlyManufacturerRequested: Boolean
    $onlyReadyForApproval: Boolean
  ) {
    bookingRequestsCount: bookings(
      customerUuid: $customerUuid
      onlyManufacturerRequested: $onlyManufacturerRequested
      onlyReadyForApproval: $onlyReadyForApproval
    ) {
      totalCount
    }
    quotesCount: bookings(onlyQuotes: true, customers: $accountIds) {
      totalCount
    }
  }
`;
